import { render, staticRenderFns } from "./veStuLeaveShow.vue?vue&type=template&id=13a6779d&scoped=true"
import script from "./veStuLeaveShow.vue?vue&type=script&lang=js"
export * from "./veStuLeaveShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a6779d",
  null
  
)

export default component.exports